import { RadioButton, type RadioItem, useMediaQuery } from "@kyan/ui";
import { type ReactNode } from "react";

import { useUserScopes } from "#/services/dynamic/hooks/useUserScopes";
import { useOption } from "#/store/options/tradePanel/option";
import { useOptionTradeType } from "#/store/options/tradePanel/optionTradeType";
import type { TradeType } from "#/types/trade";

import { EmptyState } from "./components/EmptyState/EmptyState";
import { RFQRequests } from "./components/SelectedOption/components/OptionTradeDetails/components/RFQRequests/RFQRequests";
import { SelectedOption } from "./components/SelectedOption/SelectedOption";

interface PanelContentProps {
  children?: ReactNode;
}

const getItems = (hasEarlyAccessVip: boolean): RadioItem<TradeType>[] => {
  const list: RadioItem<TradeType>[] = [
    { id: "market" as TradeType, label: "Market-Limit", className: "flex-1" },
    { id: "limit" as TradeType, label: "Limit", className: "flex-1" },
    ...(hasEarlyAccessVip
      ? [{ id: "rfq" as TradeType, label: "RFQ", className: "flex-1" }]
      : []),
  ];
  return list;
};

export const OptionsTab: React.FC<PanelContentProps> = () => {
  const { isSm } = useMediaQuery();
  const { option } = useOption();
  const { optionTradeType, setOptionTradeType, isRFQ } = useOptionTradeType();
  const { hasEarlyAccessVip } = useUserScopes();

  const handleChangeTradeType = (id: TradeType) => {
    setOptionTradeType(id);
  };

  return (
    <div className="flex h-full max-h-[65vh] flex-col overflow-y-auto sm:max-h-none">
      <RadioButton
        variant="secondary"
        value={optionTradeType}
        size={isSm ? "md" : "xl"}
        items={getItems(hasEarlyAccessVip)}
        className="mt-4.5 w-full gap-3 sm:px-4"
        onChange={handleChangeTradeType}
      />
      <div className="flex h-full flex-col py-3 sm:px-4">
        {!option ? <EmptyState /> : <SelectedOption />}
        {isRFQ && <RFQRequests />}
      </div>
    </div>
  );
};
